<template>
  <div ref="root" class="position-relative">
    <button
      type="button"
      class="cg-year-btn d-inline-flex align-items-center gap-2 rounded-pill"
      @click="open = !open"
    >
      <span class="cg-numeral cg-tabular cg-year-value">{{ year }}</span>
      <span class="cg-micro">{{ current.state }}</span>
      <font-awesome-icon
        icon="chevron-down"
        class="small"
        :class="{ 'cg-rotated': open }"
      />
    </button>
    <div v-if="open" class="cg-menu card shadow-sm p-1">
      <button
        v-for="option in options"
        :key="option.year"
        type="button"
        class="btn w-100 text-start d-flex align-items-baseline gap-2 py-2"
        :class="{ 'bg-primary-subtle': option.year === year }"
        @click="pick(option.year)"
      >
        <span class="cg-numeral cg-tabular cg-year">{{ option.year }}</span>
        <span class="text-body-secondary small flex-grow-1">{{
          option.note
        }}</span>
        <ToneBadge :tone="option.tone" :label="option.state" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { YearOption } from "@/compliance_groups/fixture/complianceGroupsTypes";
import { onClickOutside } from "@vueuse/core";
import { computed, ref, useTemplateRef } from "vue";
import ToneBadge from "./ToneBadge.vue";

const props = defineProps<{ options: YearOption[] }>();
const year = defineModel<number>("year", { required: true });

const open = ref(false);
const root = useTemplateRef<HTMLElement>("root");
onClickOutside(root, () => (open.value = false));

const current = computed(
  () => props.options.find((o) => o.year === year.value) ?? props.options[0]
);

const pick = (value: number) => {
  year.value = value;
  open.value = false;
};
</script>

<style scoped lang="scss">
.cg-year-btn {
  height: 32px;
  padding: 0 11px 0 14px;
  border: 1px solid var(--phoenix-border-color-strong, var(--phoenix-gray-300));
  background: var(--phoenix-emphasis-bg, #fff);
  color: var(--phoenix-gray-1000);
  cursor: pointer;

  &:hover {
    border-color: var(--phoenix-secondary-color);
  }
}
.cg-year-value {
  font-size: 1.25rem;
  line-height: 1;
}
.cg-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 40;
  min-width: 268px;
}
.cg-year {
  min-width: 38px;
  font-size: 1rem;
  flex-shrink: 0;
  white-space: nowrap;
}
.cg-menu .badge {
  flex-shrink: 0;
}
.cg-rotated {
  transform: rotate(180deg);
}
</style>
